"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

const getUrls = baseUrl => {
  const getUrl = url => "".concat(baseUrl).concat(url);

  return {
    GET_VIDEO: id => getUrl("/v1/user-videos/".concat(id)),
    CREATE_VIDEO: getUrl('/v1/user-videos')
  };
};

var _default = getUrls;
exports.default = _default;